<div class="label">UNITS</div>
<div class="values">
  <span [matTooltip]="'Available  Units'"
    >{{ $any(units)?.availableUnits | number : numberFormat }}</span
  >
  @if ($any(units)?.assignedUnits) { /
  <span matTooltip="Assigned Units">
    {{ $any(units)?.assignedUnits | number : numberFormat }}</span
  >
  } @if ($any(units)?.completedUnits) { /
  <span matTooltip="Completed Units"
    >{{ $any(units)?.completedUnits | number : numberFormat}}</span
  >
  }
</div>
